const mock = (s: string) => {
  console.debug('would have tracked ' + s);
};

export const trackWithPlausible =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  process.env.REACT_APP_ENABLE_TRACKING === 'true' ? window.plausible || mock : mock;
